<template>
  <div
    :class="[
      $style['form-password'],
      { [$style['form-password--reveal']]: type === 'text' }
    ]">
    <FormInput
      ref="input"
      :class="$style['form-input']"
      :model-value="modelValue"
      v-bind="attrs"
      :type="type"
      @update:model-value="onChange" />

    <SvgIcon
      title="Show password"
      :class="[
        $style['form-password__icon'],
        $style['form-password__icon--show']
      ]"
      name="System/eye-close-line"
      @click="toggle" />
    <SvgIcon
      title="Hide password"
      :class="[
        $style['form-password__icon'],
        $style['form-password__icon--hide']
      ]"
      name="System/eye-line"
      @click="toggle" />
  </div>
</template>
<script setup>
const input = ref(null)
const emit = defineEmits(['update:modelValue'])
const type = ref('password')
const attrs = useAttrs()

defineProps({
  modelValue: {
    type: [String],
    default: null
  }
})
defineOptions({
  inheritAttrs: false
})

const toggle = () => {
  type.value = type.value === 'password' ? 'text' : 'password'
}
const onChange = value => {
  emit('update:modelValue', value)
}
const focus = () => {
  input.value.focus()
}

</script>
<style lang="scss" module>
.form-password {
  position: relative;

  .form-input {
    background-image: none;
    margin-bottom: 0;

    &::-ms-reveal,
    &::-ms-clear {
      display: none;
    }
  }

  &__icon {
    fill: $grey;
    z-index: 1;
    cursor: pointer;
    display: flex;
    position: absolute;
    right: $spacing * 2;
    top: $spacing * 3;
    transform: translateY(-50%);
    width: $spacing * 2.5;

    &:hover {
      fill: $black;
    }

    &--hide {
      opacity: 0;
    }
  }

  &--reveal {
    .form-password__icon--hide {
      opacity: 1;
    }

    .form-password__icon--show {
      opacity: 0;
    }
  }
}
</style>
